import { normalizeDrawableGeometryType } from '@/features/Inventory/ObjectCreate/model/helpers.ts'
import type { InventoryMapObjectTypes } from '@/widgets/InventoryMap/model/types'

export type GeometryType = 'Point' | 'LineString' | 'Polygon'

/**
 * Resolve the geometry type for a given catalog type ID from the cached master types response.
 * Falls back to 'Point' if not found.
 */
export function resolveGeometryType(
  linkedInventoryTypeId: number | null | undefined,
  masterTypesData: InventoryMapObjectTypes[] | undefined,
): GeometryType {
  if (linkedInventoryTypeId == null || !Array.isArray(masterTypesData)) return 'Point'

  const entries = masterTypesData.flatMap((t) => [
    t,
    ...((t as any).sub_types ?? []),
  ])
  const found = entries.find((e) => e.id === linkedInventoryTypeId)
  return normalizeDrawableGeometryType(found?.figure?.geom_type)
}
